<template>
  <div>
    <div class="card card-body rounded-top">
      <div class="row no-gutters row-grid">
        <div class="col-12">
          <div class="d-flex flex-column align-items-center justify-content-center p-4">
            <!-- <img
              src="http://posmfactory.com/wp-content/uploads/2017/01/blank-user.jpg"
              width="250"
              height="300"
              class="rounded-circle shadow-2 img-thumbnail"
              alt=""
            />-->

            <h5 class="mb-0 fw-700 text-center mt-3">{{ team.name }}</h5>
          </div>
        </div>

        <detail-item
          class="col-md-6"
          :label="$t('tabs.club.clubGroup')"
        >{{ team.club.name || 'Brak' }}</detail-item>

        <detail-item
          class="col-md-6"
          :label="$t('tabs.club.discipline')"
        >{{ team.sport.name || 'Brak' }}</detail-item>

        <check-permission
          entityType="team"
          permissions="TEAM.UPDATE"
          :entityId="$route.params.teamId"
        >
          <div class="col-12 text-center">
            <button
              class="btn btn-smart btn-lg rounded-pill px-5 m-5"
              @click="showEditModal(team.id)"
            >{{ $t('buttons.edit') }}</button>
          </div>
        </check-permission>
      </div>
    </div>

    <div v-if="currentEvents.length > 0" class="card rounded-top mt-4">
      <div class="card-header py-2">
        <div class="card-title">
          <strong>{{ $t('text.current-trainings') }}</strong>
        </div>
      </div>

      <div class="card-body">
        <component-table
          entityType="presence"
          :actions="actions"
          :columns="columns"
          :data="currentEvents"
          :total="currentEvents.length"
          :hideAddButton="true"
          @presence="choosePresenceModal"
        />
      </div>
    </div>

    <team-modal
      :show="showModal"
      :id="idToEdit"
      :clubId="team.club.id"
      @close="hideModal"
      @update="update"
    />

    <presence-modal
      :show="showPresenceModal"
      :players="players"
      :event="selectedEvent"
      :id="idToPresenceEdit"
      @close="hidePresenceModal"
      @save="addPresence"
      @update="updatePresence"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

import DetailItem from '@/components/details/DetailItem';
import PresenceModal from '@/components/modals/PresenceModal';
import TeamModal from '@/components/modals/TeamModal';
import ComponentTable from '@/components/table/Table';
import { Storage } from '@/enums/storage.enum';
import { TableName } from '@/enums/tableName.enum';
import { modalMixin } from '@/mixins/modal';
import { PRESENCE_ACTION } from '@/utils/constants';
import { tryParseInt } from '@/utils/number';

// @vuese
// Profil grupy treningowej
// @group Team
export default {
  components: {
    DetailItem,
    TeamModal,
    ComponentTable,
    PresenceModal
  },
  mixins: [
    modalMixin('team', {
      updated: 'messages.team.updated',
      updateError: 'messages.team.updateError'
    })
  ],
  data() {
    return {
      idToPresenceEdit: undefined,
      showPresenceModal: false,
      currentEvents: [],
      selectedEvent: {},
      columns: [
        { name: 'name', displayName: 'columns.scheduleContainerName' },
        { name: 'hour', displayName: 'columns.hour' },
        { name: 'minute', displayName: 'columns.minute' }
      ],
      actions: [PRESENCE_ACTION]
    };
  },
  computed: {
    ...mapState({
      team: state => state.team.data,
      events: state =>
        state.events.list.map(item => ({
          ...item,
          name: item.schedule.name,
          hour: item.schedule.hour,
          minute: item.schedule.minute
        })),
      presences: state => state.presences.list,
      players: state => state.team.player.list,
      coaches: state => state.team.coach.list
    })
  },
  methods: {
    // @vuese
    // Sprawdza czy istnieje lista obecności danego wydarzenia i otwiera modala dodawania/edycji
    // @arg `event` - obiekt wydarzenia
    choosePresenceModal(event) {
      this.selectedEvent = event;

      this.$store
        .dispatch('presences/list', {
          scheduleContainerId: this.selectedEvent.container.id,
          date: this.selectedEvent.date,
          hour: this.selectedEvent.schedule.hour,
          minute: this.selectedEvent.schedule.minute
        })
        .then(() => {
          const presenceId = this.presences.length > 0 ? this.presences[0].id : undefined;

          this.selectedEvent = {
            eventContainerId: this.selectedEvent.container.id,
            eventDate: this.selectedEvent.date,
            eventHour: this.selectedEvent.schedule.hour,
            eventMinute: this.selectedEvent.schedule.minute,
            eventTitle: this.selectedEvent.schedule.name
          };

          if (presenceId) {
            this.showEditPresenceModal(presenceId);
          } else {
            this.showAddPresenceModal();
          }
        })
        .catch(() => this.notifyError('messages.presence.listError'));
    },
    // @vuese
    // Otwiera modal do edycji listy obecności
    showEditPresenceModal(id) {
      this.idToPresenceEdit = id;
      this.$store
        .dispatch('presences/get', id)
        .then(() => this.showAddPresenceModal())
        .catch(err => this.notifyError('messages.presence.getError'));
    },
    // @vuese
    // Otwiera modal do dodania listy obecności
    showAddPresenceModal() {
      this.showPresenceModal = true;
    },
    // @vuese
    // Ukrywa modal dodawania/edycji listy obecności
    hidePresenceModal() {
      this.selectedEvent = {};
      this.$set(this, 'showPresenceModal', false);
      this.$set(this, 'idToPresenceEdit', undefined);
    },
    // @vuese
    // Zapisuje listę obecności
    addPresence(data) {
      this.$store
        .dispatch('presences/add', this.deepClone(data))
        .then(() => {
          this.notifySuccess('messages.presence.added');
          this.hidePresenceModal();
        })
        .catch(err => {
          err.message
            ? this.notifyError('messages.presence.addError'[err.message])
            : this.notifyError('messages.presence.addError');
        });
    },
    // @vuese
    // Aktualizuje listę obecności
    updatePresence(data) {
      this.$store
        .dispatch('presences/update', this.deepClone(data))
        .then(() => {
          this.notifySuccess('messages.presence.updated');
          this.hidePresenceModal();
        })
        .catch(err => this.notifyError('messages.presence.updateError'));
    }
  },
  mounted() {
    const teamId = tryParseInt(this.$route.params.teamId);

    const permissions = [`PRESENCE.ADD:${TableName.Team}:${teamId}`, `PRESENCE.LIST:${TableName.Team}:${teamId}`];

    this.$store.dispatch('auth/checkPermissions', permissions).then(res => {
      if (permissions.every(permission => !!res[permission])) {
        const profileId = tryParseInt(localStorage.getItem(Storage.PROFILE_ID));

        if (this.coaches.some(coach => coach.id === profileId)) {
          const today = moment();

          this.currentEvents = this.events.filter(event => {
            const start = moment(event.date)
              .hour(event.schedule.hour)
              .minute(event.schedule.minute);
            const end = moment(event.date)
              .hour(event.schedule.hour)
              .minute(event.schedule.minute)
              .add(event.schedule.duration, 'm');

            return today.isBetween(start, end);
          });
        }
      }
    });
  }
};
</script>
